import React from "react"
import PropTypes from "prop-types"

class DashMoreToDoSection extends React.Component {
  constructor(props) {
    super(props)

    this.renderLanguageText = this.renderLanguageText.bind(this)
    this.renderBlogPosts = this.renderBlogPosts.bind(this)
  }

  renderLanguageText() {
    if (this.props.languages.length === 1) {
      return `Find ${this.props.languages[0].language.language} book suggestions from other Lexody members! Suggest your favorite ${this.props.languages[0].language.language} language books, for future learners!`
    } else if (this.props.languages.length === 2) {
      return `Find ${this.props.languages[0].language.language} and ${this.props.languages[1].language.language} book suggestions from other Lexody members! Suggest your favorite foreign language books, for future ${this.props.languages[0].language.language} and ${this.props.languages[1].language.language} learners!`
    } if (this.props.languages.length > 2) {
      return `Find ${this.props.languages[0].language.language}, ${this.props.languages[1].language.language} and ${this.props.languages[2].language.language} book suggestions from other Lexody members! Suggest your favorite foreign language books, for future learners!`
    }
  }

  renderBlogPosts() {
    return this.props.blogPosts.map((blog) => {
      return (
        <div
          key={blog.created_at}
          style={{paddingRight: 10, cursor: 'pointer'}}
          onClick={() => window.open(`https://${blog.url}`, '_blank')}>
          <img
            src={blog.image_url}
            style={{
              width: 150,
              height: 150,
              borderRadius: 10,
              objectFit: 'cover'
            }} />
            <p style={{
              marginTop: 10,
              fontSize: 14,
              fontWeight: 700
            }}>{blog.title}</p>
        </div>
      )
    })
  }

  render() {
    return(
      <div className="moreToDoSection">
        <h2 className="modalHeader" style={{marginTop: 50, marginBottom: 20}}>More ways to practice</h2>
        <h4 className="sectionText" style={{marginBottom: 20}}>Fluency requires immersion. More ways to immerse and practice any language!</h4>
        <div className="whiteStandardContainer">
          <h2 className="modalHeader">Practice Reading</h2>
          <div style={{display: 'flex', flexDirection: (this.props.width < 400 ? 'column' : 'row')}}>
            <div style={{textAlign: 'center'}}>
              <img
                style={{width: 150}}
                src={this.props.readingIcon} />
            </div>
            <div style={{paddingLeft: this.props.width < 400 ? 0 : 20}}>
              <h3 className="sectionText">{this.renderLanguageText()}</h3>
              <button onClick={() => window.location.assign("/language_resources/books")} className="small_button_secondary" style={{float: 'right', marginTop: 20}}>Search Books</button>
            </div>
          </div>
        </div>
        <div className="whiteStandardContainer" style={{marginTop: 30}}>
          <h2 className="modalHeader">Practice Writing</h2>
          <div style={{display: 'flex', flexDirection: (this.props.width < 400 ? 'column' : 'row')}}>
            <div style={{textAlign: 'center'}}>
              <img style={{width: 150}} src={this.props.writingIcon} />
            </div>
            <div style={{paddingLeft: this.props.width < 400 ? 0 : 20}}>
              <h3 className="sectionText">Let’s face it... *you* are the best thing to talk about! Each week, a new writing prompt is available. Try responding in every language you know. Your answers will be posted on your profile!</h3>
              <button onClick={() => window.location.assign("/writing_practice")} className="small_button_secondary" style={{float: 'right', marginTop: 20}}>See this week’s writing prompt</button>
            </div>
          </div>
        </div>
        <div style={{marginTop: 30, overflow: 'auto'}}>
          <h2 className="modalHeader">On the blog</h2>
          <div style={{display: 'flex', flexDirection: 'row', margin: 'auto'}}>
            {this.renderBlogPosts()}
            <div style={{width: 150}}>
            <p
              style={{width: 150, marginTop: 75, marginLeft: 15, color: '#03a9f4', cursor: 'pointer', fontSize: 14}}
              onClick={() => window.open(`/blog`, '_blank')}>See all</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DashMoreToDoSection;
